var map = {
	"./android.svg": "DfSc",
	"./computer.svg": "i/3Z",
	"./download.svg": "+H2/",
	"./ios.svg": "+yoS",
	"./mac.svg": "yBZh",
	"./mobile.svg": "ofrD",
	"./windows.svg": "FhIN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1